export const content = {
  title: 'Sorry, something went wrong',
  subTitle: `We apologize for any inconvenience this may cause.
  A Care Center representative is available to answer questions Mon - Fri, 8AM - 7PM EST.`,
};
